var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.fullscreenLoading,
          expression: "fullscreenLoading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "app-container",
    },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "label-width": "80px",
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "default-sort": _vm.defaultSort,
        },
        on: {
          afterFetchOriginalData: _vm.getInvoiceTableData,
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
          "sort-change": _vm.sortChange,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.searchIDs"),
                          prop: "invoiceId",
                        },
                      },
                      [
                        _c("BjInputNumber", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("billingPage.searchID"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.invoiceId,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "invoiceId", $$v)
                            },
                            expression: "queryParams.invoiceId",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.totalAmount"),
                          prop: "totalAmount",
                        },
                      },
                      [
                        _c("BjInputMoney", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("billingPage.totalAmount"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.totalAmount,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "totalAmount", $$v)
                            },
                            expression: "queryParams.totalAmount",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.companySeller"),
                          prop: "companyName",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.clientCodeList,
                            placeholder: _vm.$t("billingPage.companySeller"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.companyName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "companyName", $$v)
                            },
                            expression: "queryParams.companyName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.yearAndWeek"),
                          prop: "year",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            id: "getWeekDate",
                            "picker-options": { firstDayOfWeek: 1 },
                            type: "week",
                            format: "yyyy-WW",
                            clearable: false,
                            placeholder: _vm.$t("billingPage.yearAndWeeks"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.weekDataNow,
                            callback: function ($$v) {
                              _vm.weekDataNow = $$v
                            },
                            expression: "weekDataNow",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.InvoiceWeek"),
                          prop: "year",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            id: "invoiceWeek",
                            "picker-options": { firstDayOfWeek: 1 },
                            type: "week",
                            format: "yyyy-WW",
                            clearable: false,
                            placeholder: _vm.$t("billingPage.yearAndWeeks"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.invoiceWeek,
                            callback: function ($$v) {
                              _vm.invoiceWeek = $$v
                            },
                            expression: "invoiceWeek",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.Status"),
                          prop: "state",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            clearable: false,
                            "option-list": _vm.BILLING_PAGE_STATUS,
                            placeholder: _vm.$t("billingPage.Status"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "state", $$v)
                            },
                            expression: "queryParams.state",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BjDialogListConfig.Types"),
                          prop: "type",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            clearable: false,
                            "option-list": _vm.typeList,
                            placeholder: _vm.$t("BjDialogListConfig.Types"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "type", $$v)
                            },
                            expression: "queryParams.type",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-dropdown",
                      {
                        directives: [
                          {
                            name: "hasDropdownChildren",
                            rawName: "v-hasDropdownChildren",
                          },
                        ],
                        on: { command: _vm.handleMatch },
                      },
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v(" " + _vm._s(_vm.$t("billingPage.actions"))),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right",
                          }),
                        ]),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: { command: 1, type: "primary" },
                                on: { click: _vm.onGroupPDF },
                              },
                              [_vm._v(_vm._s(_vm.$t("billingPage.ExportPDF")))]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: { command: 2, type: "primary" },
                                on: { click: _vm.onGroupCSV },
                              },
                              [_vm._v(_vm._s(_vm.$t("billingPage.ExportCSV")))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    !["bjTableAction", "totalAmount", "paidAmount"].includes(
                      col.prop
                    )
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "id"
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.isNew == 1
                                                  ? "New " + scope.row.id
                                                  : scope.row.id
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : col.prop === "Period"
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row.periodFrom
                                                )
                                              ) +
                                              "~" +
                                              _vm._s(
                                                _vm._f("timeFilters")(
                                                  scope.row.periodTo
                                                )
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : col.prop === "week"
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                scope.row.week +
                                                  "/" +
                                                  scope.row.year
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : col.prop === "state"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type:
                                                scope.row.state == "PAID"
                                                  ? "success"
                                                  : "info",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.BILLING_PAGE_STATUS.bjGet(
                                                      scope.row.state
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "totalAmount"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "total_amount",
                            title: col.label,
                            sortable: "",
                            width: "135px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("timeFilters")(
                                          scope.row[col.prop],
                                          scope.row[col.prop]
                                        )
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : col.prop === "paidAmount"
                      ? _c("vxe-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            align: "center",
                            field: "paid_amount",
                            title: col.label,
                            sortable: "",
                            width: "135px",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("timeFilters")(
                                          scope.row[col.prop],
                                          scope.row[col.prop]
                                        )
                                      )
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "PDF",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass: "edit-btn",
                                          staticStyle: { "font-size": "20px" },
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-download",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onPDF(props.row)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: "XLSX",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          staticClass: "edit-btn",
                                          staticStyle: { "font-size": "20px" },
                                          attrs: {
                                            type: "text",
                                            icon: "el-icon-document",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onXLSX(props.row)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("el-button", {
                                      directives: [
                                        {
                                          name: "permission",
                                          rawName:
                                            "v-permission:BillingInvoiceEdit",
                                          arg: "BillingInvoiceEdit",
                                        },
                                      ],
                                      staticClass: "edit-btn",
                                      staticStyle: { "font-size": "20px" },
                                      attrs: {
                                        type: "text",
                                        icon: "el-icon-edit-outline",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onEdit(props.row)
                                        },
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("billingPage.UpdateInvoicePayment"),
            visible: _vm.dialogFormVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("billingPage.totalAmount") } },
                [
                  _vm._v(": "),
                  _c("BjInput", {
                    staticStyle: { width: "300px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.totalAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "totalAmount", $$v)
                      },
                      expression: "form.totalAmount",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("billingPage.PaidAmount") } },
                [
                  _vm._v(": "),
                  _c("BjInput", {
                    staticStyle: { "margin-left": "3px", width: "300px" },
                    model: {
                      value: _vm.form.paidAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "paidAmount", $$v)
                      },
                      expression: "form.paidAmount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveAmount()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }